// Make it globally available

window.KachingBundleUI = {
  init: function() {
    const bars = document.querySelectorAll('.kaching-bundles__bars');
    if (bars.length) {
      this.initBundleBars(bars);
    }
  },

  initBundleBars: function(bars) {
    const bundleInfo = this.extractBundleInfo(bars[0]);
    this.createBundleTabs(bundleInfo, bars[0]);
  },

  extractBundleInfo: function(barsContainer) {
    return Array.from(barsContainer.querySelectorAll('.kaching-bundles__bar') || []).map(bar => {
      const hotDealEl = bar.querySelector('.kaching-bundles__bar-most-popular__content');
      const titleEl = bar.querySelector('.kaching-bundles__bar-title');
      const subtitleEl = bar.querySelector('.kaching-bundles__bar-subtitle');
      
      return {
        pieces: titleEl ? titleEl.textContent.trim() : '',
        savings: subtitleEl ? subtitleEl.textContent.trim() : '',
        isSelected: bar.classList.contains('kaching-bundles__bar--selected'),
        hotDealText: hotDealEl ? hotDealEl.textContent.trim() : ''
      };
    });
  },

  createBundleTabs: function(bundleInfo, barsContainer) {
    if (!barsContainer || document.querySelector('.bundle-tabs')) return;

    const barContainers = barsContainer.querySelectorAll('.kaching-bundles__bar-container') || [];
    barContainers.forEach(container => {
      if (!container) return;
      
      const parentBar = container.closest('.kaching-bundles__bar');
      if (!parentBar) return;
      
      if (!parentBar.classList.contains('kaching-bundles__bar--selected')) {
        container.style.display = 'none';
      }
    });

    const tabsHtml = `
      <div class="bundle-tabs">
        <div class="bundle-tabs__container">
          ${bundleInfo.map(info => `
              <div class="bundle-tab ${info.isSelected ? 'active' : ''}" data-pieces="${info.pieces}">
                ${info.hotDealText ? `<div class="hot-deal">${info.hotDealText}</div>` : ''}
                <div class="bundle-tab__pieces">${info.pieces}</div>
                <div class="bundle-tab__savings">${info.savings}</div>
              </div>
            `).join('')}
        </div>
      </div>
    `;

    const tabsStyle = `
      <style>

        .kaching-bundles__block-title{
          display: none!important;
        }
        .kaching-bundles__bar-container {
          margin-bottom: 10px !important;
        }
        .bundle-tabs {
        }
        .bundle-tabs__title {
          font-size: 18px;
          color: #4F46E5;
          margin-bottom: 10px;
        }
        .bundle-tabs__container {
          display: flex;
          gap: 0px;
          width: 100%;
          z-index: 10;
        }
        .bundle-tab {
          flex: 1;
          padding: 8px 10px;
          padding-bottom: 4px;
          cursor: pointer;
          background: white;
          border: 1px solid #e5e5e5;
          border-radius: 15px;
          text-align: center;
          position: relative;
          transition: all 0.3s ease;
          color: #408CFF;
          z-index: 2;

          border-radius: 10px;
          background: linear-gradient(#fff, #fff) padding-box, linear-gradient(90deg, #7ff8ff, #6ba6ff) border-box;
          border: 2px solid transparent;
        
        }

        .bundle-tab:not(:first-child){
          margin-left: -2px;
        }

        .bundle-tab:hover {
          border-color: #4F46E5;
          z-index: 2;
        }
        .bundle-tab.active {
          background: linear-gradient(to bottom, #00EBFF, #7394FF);
          border: none;
          color: #4F46E5;
          z-index: 2;
        }


        .bundle-tab__pieces {
          font-weight: bold;
          font-size: 16px;
          line-height: 1;
        }
        .bundle-tab__savings {
          font-size: 12px;
          opacity: 0.9;
        }
        .hot-deal {
          position: absolute;
          top: -9px;
          right: 5%;
          background: linear-gradient(to right, #8b56ff, #f95dff) !important;
          font-weight: 600;
          color: white;
          padding: 2px 4px;
          border-radius: 12px;
          font-size: 8px;
          white-space: nowrap;
        }
        .active .bundle-tab__savings {
          color: #4F46E5!important;
        }
        /* Keep only the selects visible in the original bundle bars */
        .kaching-bundles__bar-variants {
          margin-top: 0 !important;
        }

        .kaching-bundles__bar{
          display: none!important;
        }

        .kaching-bundles__bar--selected{
          display: flex!important;
        }

        .kaching-bundles__bar-most-popular{
          display: none!important;
        }

        .kaching-bundles .kaching-bundles__bar{
          margin:0!important  ;
          border-top-left-radius: 0!important;
          border-top-right-radius: 0!important;
        }

        .kaching-bundles__bar--selected label{
          background: #defffe !important;
          border: 0px;
          box-shadow: none!important;
          color: white !important;
          border-top-left-radius: 0!important;
          border-top-right-radius: 0!important;
      }

      .kaching-bundles__bar-variants{
        margin-top: 0!important;
      }

      .kaching-bundles__bar-variant-names{
        display: none!important;
      }

      .kaching-bundles__bar-variant-number{
        color: white!important;
      }

      .kaching-bundles .kaching-bundles__bar-container{
        border-radius: 8px!important;
        border-top-left-radius: 0!important;
        border-top-right-radius: 0!important;
        margin-top: -10px !important;
      }

      .kaching-bundles .kaching-bundles__bar-variants .kaching-bundles__bar-variant{
          flex: 1;
          width: 100%;
      }

      .kaching-bundles .kaching-bundles__bar-variant-select{
        font-size: 16px!important;
        color: #4440C4!important;
        font-weight: 600!important;
        text-align: center!important;
        padding: 4px 14px 4px 7px!important;
        width: calc(50% - 60px)!important;
      }

      .kaching-bundles .kaching-bundles__bar-variant-selects{
        width: 100%;
        justify-content: center;
      }

      .kaching-bundles .kaching-bundles__bar-content{
        justify-content: center!important;
      }


      .kaching-bundles .kaching-bundles__bar-variants{
          justify-content: flex-start !important;
      }

      .kaching-bundles__bar-variant-number{
          display: none!important;
      }

      /*.kaching-bundles .kaching-bundles__bar-container *{
          justify-content: center!important;
      }*/


      .kaching-bundles .kaching-bundles__bar-variant-select {
        box-shadow: 0 0 0 1px #7ff8ff, 0 0 0 2px rgba(107, 166, 255, 0.3) !important;
  border: none !important;
  background: white !important;
        }


        .kaching-bundles__bar-radio, .kaching-bundles__bar-content-left{
          display: none!important;
        }

        .kaching-bundles .kaching-bundles__bar-pricing{
            flex-direction: row-reverse !important;
            gap: .8em;
            align-items: center!important;
        }  

        .kaching-bundles .kaching-bundles__bar-main{
          min-height: unset!important;
          margin: 0!important;
          padding-top: 10px !important;
          padding-bottom: 0 !important;
        }

        .kaching-bundles .kaching-bundles__bar-wrapper{
          padding: 0!important;
          display: flex;
          flex-direction: column-reverse;
        }


          .kaching-bundles__bar-full-price{
              font-size: 20px !important;
            color: #4440C4 !important;
            font-weight: 600!important;
            opacity: .7!important;
          }

          .kaching-bundles__bar-price{
              font-size: 20px !important;
            color: #4440C4 !important;
            font-weight: 600!important;
          }


        .kaching-bundles .kaching-bundles__bar-variant__content{
          justify-content: center!important;
        }

        .kaching-bundles__bar-variants{
          padding-top: 20px!important;
        }

        .kaching-bundles__bar-pricing{
          padding-left: 15px!important;
          padding-bottom: 15px!important;
        }

        @media(max-width: 786px){
          .bundle-tab__savings{
            font-size: 9px;
          }

          .kaching-bundles .kaching-bundles__bar-variant-select{
            font-size: 12px!important;
          }
        }
          
      </style>
    `;

    barsContainer.insertAdjacentHTML('beforebegin', tabsStyle + tabsHtml);

    // Update click handler to show/hide variants
    document.querySelectorAll('.bundle-tab').forEach(tab => {
      if (!tab) return;
      
      tab.addEventListener('click', () => {
        document.querySelectorAll('.bundle-tab').forEach(t => t?.classList.remove('active'));
        tab.classList.add('active');
        
        const pieces = tab.dataset.pieces;
        if (!pieces) return;

        barContainers.forEach(container => {
          if (!container) return;
          
          const bar = container.closest('.kaching-bundles__bar');
          if (!bar) return;
          
          const titleEl = bar.querySelector('.kaching-bundles__bar-title');
          const barTitle = titleEl ? titleEl.textContent.trim() : '';
          container.style.display = barTitle === pieces ? 'block' : 'none';
        });
        
        const targetBar = Array.from(barsContainer.querySelectorAll('.kaching-bundles__bar') || [])
          .find(bar => {
            const titleEl = bar?.querySelector('.kaching-bundles__bar-title');
            return titleEl && titleEl.textContent.trim() === pieces;
          });
        
        if (targetBar) {
          const radio = targetBar.querySelector('input[type="radio"]');
          radio?.click();
        }
      });
    });
  }
};

document.addEventListener('DOMContentLoaded', () => {
  const bundleObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      const bars = document.querySelectorAll('.kaching-bundles__bars');
      if (bars.length) {
        KachingBundleUI.init();
        bundleObserver.disconnect();
      }
    });
  });

  bundleObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
});